// components/PatternedBackground.js
import React from "react";
import element1 from "../assets/UiElements/Pattern Element 3.svg";
import element2 from "../assets/UiElements/Pattern Element 5.svg";

const PatternedBackground = ({ children, style = {} }) => {
    return (
        <div
            style={{
                position: "relative",
                backgroundColor: "#ffffff",
                width: "100%",
                height: "100%",
                overflow: "hidden",
                ...style,
            }}
        >

            <img
                src={element1}
                alt="decor"
                style={{ position: "absolute", top: 0, right: 0, width: 500 }}
            />


            <img
                src={element2}
                alt="decor"
                style={{ position: "absolute", bottom: 0, left: 0, width: 500 }}
            />


            <div style={{ position: "relative", zIndex: 1 }}>
                {children}
            </div>
        </div>
    );
};

export default PatternedBackground;
